<template>
	<div class="documentation">
		<div class="header">
			<div class="float-left">
				<h3>{{ i18n.__( 'Guides and Documentation', 'post-smtp' ) }}</h3>
			</div>
			<div class="float-right">
				<a href="https://postmansmtp.com/documentation/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin">{{ i18n.__( 'View All', 'post-smtp' ) }}</a>

				<a
					href="#"
					@click="e => toggleTransition( e )"
					style="box-shadow: none;border: none;outline: none;"
				>
					<img
						class="transform-image maximize"
						style="margin-left: 10px;"
						:src="plugin_dir_url + 'assets/images/maximize.png'"
					>
				</a>
			</div>
		</div>

		<transition
			name="fade"
			enter-active-class="animated slideIn"
		>
			<div v-if="show_documentation" class="body">
				<div class="content">
					<post-smtp-documentation
						v-for="doc in documentation" :key="doc.title"
						:title="doc.title"
						:docs-links="doc.links"
						:view-more="doc.view_more"
						:plugin-dir-url="plugin_dir_url"
						:admin-url="admin_url"
					></post-smtp-documentation>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'PostSMTPGuide',
	inject: [ 'i18n' ],

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
		documentation: [
			{
				title: vm.i18n.__( 'Getting Started', 'post-smtp' ),
				links: [
					{
						title: vm.i18n.__( 'Installation and Activation Guide', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/postman-smtp-documentation/activation-and-installation/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Email Logs', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/postman-smtp-documentation/email-logs/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
				],
				view_more: 'https://postmansmtp.com/documentation/postman-smtp-documentation/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
			},
			{
				title: vm.i18n.__( 'Socket', 'post-smtp' ),
				links: [
					{
						title: vm.i18n.__( 'Complete Mailer Guide', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/sockets-addons/post-smtp-complete-mailer-guide/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Gmail /Google Workspace With Post SMTP', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/sockets-addons/gmail/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Office/Microsoft 365(PRO) with Post SMTP', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/sockets-addons/how-to-configure-post-smtp-with-office-365/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
				],
				view_more: 'https://postmansmtp.com/documentation/sockets-addons/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
			},
			{
				title: vm.i18n.__( 'Advance Functionality', 'post-smtp' ),
				links: [
					{
						title: vm.i18n.__( 'Email Report and Tracking', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/advance-functionality/report-and-tracking-extension/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Advance Delivery and Logs', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/advance-functionality/advance-delivery-logs/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Email Log Attachment', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/advance-functionality/email-log-attachment/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
				],
				view_more: 'https://postmansmtp.com/documentation/advance-functionality/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
			},
			{
				title: vm.i18n.__( 'Post SMTP Mobile App', 'post-smtp' ),
				links: [
					{
						title: vm.i18n.__( 'Download the app and connect with plugin', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/post-smtp-mobile-app/download-the-app-and-connect-with-plugin/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Connect and Monitor Multiple WordPress Sites', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/post-smtp-mobile-app/connect-and-monitor-wordpress-multiple-sites-88137/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Resend Failed Email from Mobile App', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/post-smtp-mobile-app/resend-failed-emails-88130/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
				],
				view_more: 'https://postmansmtp.com/documentation/post-smtp-mobile-app/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
			},
			{
				title: vm.i18n.__( 'MainWP Extension', 'post-smtp' ),
				links: [
					{
						title: vm.i18n.__( 'Configure MainWP Post SMTP Extension', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/mainwp-extension/configure-mainwp-post-smtp-extension/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'Configure MainWP Dashboard for MainWP Post SMTP Extension', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/mainwp-extension/configure-mainwp-dashboard-for-mainwp-post-smtp-extension/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
				],
				view_more: 'https://postmansmtp.com/documentation/mainwp-extension/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
			},
			{
				title: vm.i18n.__( 'Tools and Troubleshooting', 'post-smtp' ),
				links: [
					{
						title: vm.i18n.__( 'How to get Diagnostic test report?', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/tools-and-troubleshooting/how-to-get-diagnostic-test-report/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
					{
						title: vm.i18n.__( 'How to get a Connectivity test report?', 'post-smtp' ),
						href: 'https://postmansmtp.com/documentation/tools-and-troubleshooting/how-to-get-a-connectivity-test-report/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
					},
				],
				view_more: 'https://postmansmtp.com/documentation/tools-and-troubleshooting/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin',
			},
		],
		show_documentation: true,
	} ),

	methods: {
		toggleTransition( e ) {
			e.preventDefault();
			const image = document.querySelector( '.transform-image' );
			image.classList.toggle( 'minimize' );

			this.show_documentation = ! this.show_documentation;
		}
	}
}
</script>

<style scoped>
.documentation * {
	padding: 0;
	margin: 0;
}
.header {
	border-radius: 4px 4px 0 0;
	border-width: 1px 1px 0 1px;
	border-style: solid;
	border-color: #DCDFE5;
	padding: 16px 24px;
	background: #FFFFFF;
}

.header h3 {
	font-family: Poppins;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	text-align: left;
	color: #231F20;
}

.float-left {
	float: left;
}

.float-right {
	float: right;
}

.header::after {
	content: '';
	display: block;
	clear: both;
}

.transform-image {
	transform: rotate(0deg);
	transition: transform 0.5s;
}

.maximize {
	transform: rotate(180deg);
}

.minimize {
	transform: rotate(0deg);
}

.body {
	background: #EFF4FD;
	border-width: 0 1px 1px 1px;
	border-style: solid;
	border-color: #DCDFE5;
	padding: 48px 0;
}

.body {
	width: calc( 100% - 2px );
	display: flex;
	justify-content: center;
	align-items: center;
}

.content {
	display: grid;
	grid-template-columns: auto auto auto;
}

.content::after {
	content: '';
	display: block;
	clear: both;
}
</style>